import { mapActions, mapGetters, mapState } from 'vuex';

import { getMenuTopToContentHeight } from '@/utils/helper';

export default {
  name: 'MenuItems',
  props: {
    items: {
      required: true,
      type: Array,
    },
    entreeLimit: {
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      observer: {},
      visibleArea: 0,
      visibleSince: 0,
    };
  },
  beforeDestroy() {
    this.observer.disconnect();
    this.setActivatedCategory(null);
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  mounted() {
    const top = getMenuTopToContentHeight();
    const options = {
      delay: 100,
      rootMargin: `-${top}px 0px -50%`,
      threshold: [0, 1],
      trackVisibility: true,
    };
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.visibleArea = 0;
          const targetId = entry.target.getAttribute('id');
          if (
            entry.isIntersecting
            && entry.intersectionRatio > 0
            && entry.isVisible
            && entry.time > this.visibleSince
          ) {
            if (this.activatedCategory !== targetId) {
              this.visibleArea = entry.intersectionRatio;
            }
            if (this.visibleArea >= entry.intersectionRatio) {
              this.setActivatedCategory(targetId);
            }
            this.visibleSince = entry.time;
          }
        });
      },
      options,
    );
    document.querySelectorAll('.menu-items > div').forEach((section) => {
      this.observer.observe(section);
    });
  },
  computed: {
    ...mapGetters('cart', [
      'cartItems',
      'cartMenuId',
    ]),
    ...mapState('menu', ['activatedCategory']),
  },
  methods: {
    ...mapActions('menu', {
      setActivatedCategory: 'SET_ACTIVATED_CATEGORY',
    }),
    itemCount(itemIndex) {
      if (this.cartMenuId !== this.$route?.params?.id) {
        return 0;
      }

      return this.cartItems
        .filter(({ index }) => itemIndex === index)
        .map(({ count }) => count)
        .reduce((pre, cur) => pre + cur, 0);
    },
    itemAvailable(itemIndex) {
      const entreeLimit = this.entreeLimit || {};
      const { available = 0 } = entreeLimit[itemIndex] || {};
      return Math.max(available - this.itemCount(itemIndex), 0);
    },
    hasItemLimit(itemIndex) {
      const entreeLimit = this.entreeLimit || {};
      return !!entreeLimit[itemIndex];
    },
    sortEntrees(entrees) {
      return entrees.sort((a, b) => a.viewIndex - b.viewIndex);
    },
  },
};
